// src/components/OrderPageComponents/OrderPage.js
import React from 'react';
import OrderPageContainer from './OrderPageContainer';

function OrderPage() {
    return <OrderPageContainer/>;
}

export default OrderPage;
